export default __webpack_public_path__ + "static/media/250dc.74d4625b.svg";